import { createSlice } from "@reduxjs/toolkit";
import { getMemberActionStatusesAPI } from "../../services/getMemberActionStatuses";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getMemberActionStatusesSlice = createSlice({
  name: "getMemberActionStatuses",
  initialState: data,
  reducers: {
    getMemberActionStatusesInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getMemberActionStatusesInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.error = "";
    },
    getMemberActionStatusesInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getMemberActionStatusesInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getMemberActionStatusesHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getMemberActionStatusesAction.getMemberActionStatusesInfo());
    const response = await getMemberActionStatusesAPI(payload ?? {});
    dispatch(
      getMemberActionStatusesAction.getMemberActionStatusesInfoSuccess(
        response,
      ),
    );
  } catch (e) {
    dispatch(
      getMemberActionStatusesAction.getMemberActionStatusesInfoFailure(
        e?.response?.data?.message || e?.message || e,
      ),
    );
  }
};

export default getMemberActionStatusesSlice.reducer;
export const getMemberActionStatusesAction =
  getMemberActionStatusesSlice.actions;
